var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29306",
    "data-name": "Group 29306",
    transform: "translate(-1244.812 11226.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1244.812 -11226.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29290",
    "data-name": "Group 29290",
    transform: "translate(802.812 -11530.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49724",
    "data-name": "Path 49724",
    d: "M21.145,11.625,19.034,9.763,21.07,7.82a.288.288,0,0,0-.12-.485l-2.71-.782,1-2.623a.287.287,0,0,0-.046-.285.291.291,0,0,0-.271-.1l-2.786.449-.227-2.8a.288.288,0,0,0-.165-.237.292.292,0,0,0-.289.023L13.135,2.574,11.724.144a.291.291,0,0,0-.5,0L9.6,2.933,6.8,1.316a.292.292,0,0,0-.29,0,.288.288,0,0,0-.146.249L6.358,4.371,3.546,4.139a.291.291,0,0,0-.262.123.287.287,0,0,0-.024.287l1.2,2.537-2.641.99a.288.288,0,0,0-.082.493l2.182,1.779-1.958,2.02a.288.288,0,0,0,.139.48l2.739.676-.9,2.66A.287.287,0,0,0,4,16.468a.291.291,0,0,0,.275.092L7.043,16l.336,2.786a.289.289,0,0,0,.174.231.292.292,0,0,0,.288-.034L10.1,17.3l1.505,2.3a.291.291,0,0,0,.5-.02l1.315-2.405,2.383,1.5a.292.292,0,0,0,.29.012.288.288,0,0,0,.155-.244l.117-2.8,2.8.341a.291.291,0,0,0,.267-.113.287.287,0,0,0,.035-.286L18.367,13l2.677-.887a.288.288,0,0,0,.1-.489Z",
    transform: "translate(457.365 312)",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    cx: 5.977,
    cy: 5.972,
    rx: 5.977,
    ry: 5.972,
    transform: "translate(462.763 315.844)",
    fill: "#ffdb2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49725",
    "data-name": "Path 49725",
    d: "M243.256,99.743q-.225,0-.445.016a5.972,5.972,0,0,1,0,11.911q.22.016.445.016a5.972,5.972,0,1,0,0-11.944Z",
    transform: "translate(225.484 216.101)",
    fill: "#ffca00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunHighlighted);
export default __webpack_public_path__ + "static/media/sunHighlighted.6aa94e3e59c136badb65ceb0036acbcc.svg";
export { ForwardRef as ReactComponent };